import { TFunction } from 'i18next';
import { HardwareFirstGiftTermMonths } from '../../lib/hardwareFirstGiftPlans';

export const GIFT_TERM_LABEL_KEYS: Record<HardwareFirstGiftTermMonths, string> = {
  6: 'hardware_first_gift_term_6m',
  12: 'hardware_first_gift_term_12m',
  24: 'hardware_first_gift_term_24m',
};

export function giftPlanRowLabel(t: TFunction, months: HardwareFirstGiftTermMonths, trackerCount: number): string {
  return t(
    trackerCount === 1 ? 'hardware_first_cart_gift_summary_row_one' : 'hardware_first_cart_gift_summary_row_other',
    {
      term: t(GIFT_TERM_LABEL_KEYS[months]),
      count: trackerCount,
    },
  );
}
